import { BADGE_KIND } from '@/components/Badge';
import type { BadgeKind } from '@/components/Badge';

export type ProfileTabValue = 'unconnected' | 'connected' | 'deleted' | 'all';

export interface ProfileTabConfig {
  name: string;
  value: ProfileTabValue;
  gridColsXL: 6 | 7 | 8;
  showLinkedCardCol: boolean;
  showStateCol: boolean;
  apiType: string;
  apiStatus: string;
  badgeColor: BadgeKind;
  rowActions: {
    export: boolean;
    move: boolean;
    delete: boolean;
    restore: boolean;
  };
  footerActions: {
    move: boolean;
    export: boolean;
    delete: boolean;
    restore: boolean;
  };
}

const PROFILE_TAB_CONFIGS: ProfileTabConfig[] = [
  {
    name: 'Unconnected',
    value: 'unconnected',
    gridColsXL: 6,
    showLinkedCardCol: false,
    showStateCol: false,
    apiType: 'unconnected',
    apiStatus: '',
    badgeColor: BADGE_KIND.AMBER,
    rowActions: { export: true, move: true, delete: true, restore: false },
    footerActions: { move: true, export: true, delete: true, restore: false },
  },
  {
    name: 'Connected',
    value: 'connected',
    gridColsXL: 7,
    showLinkedCardCol: true,
    showStateCol: false,
    apiType: 'connected',
    apiStatus: '',
    badgeColor: BADGE_KIND.GREEN,
    rowActions: { export: true, move: true, delete: false, restore: false },
    footerActions: { move: true, export: true, delete: false, restore: false },
  },
  {
    name: 'Deleted',
    value: 'deleted',
    gridColsXL: 8,
    showLinkedCardCol: true,
    showStateCol: true,
    apiType: '',
    apiStatus: 'deleted',
    badgeColor: BADGE_KIND.RED,
    rowActions: { export: false, move: false, delete: false, restore: true },
    footerActions: { move: false, export: false, delete: false, restore: true },
  },
  {
    name: 'All profiles',
    value: 'all',
    gridColsXL: 8,
    showLinkedCardCol: true,
    showStateCol: true,
    apiType: 'all',
    apiStatus: '',
    badgeColor: BADGE_KIND.GRAY,
    rowActions: { export: true, move: true, delete: false, restore: false },
    footerActions: { move: true, export: true, delete: false, restore: false },
  },
];

export default PROFILE_TAB_CONFIGS;
